import React from 'react';
import Styles from '../ClubSpecs.module.scss';

const DriverFairwayHybridSpec = (props) => {
  const { clubItem, getFormattedDate } = props;
  const { attributes } = clubItem;

  return (
    <>
      {clubItem?.enterDate && (
        <div className={Styles.specItem}>
          BUILD DATE:
          <span className={Styles.specValue}>
            {getFormattedDate(new Date(clubItem.enterDate))}
          </span>
        </div>
      )}
      {attributes?.head && (
        <div className={Styles.specItem}>
          HEAD:
          <span className={Styles.specValue}>{attributes.head}</span>
        </div>
      )}
      {attributes?.dexterity && (
        <div className={Styles.specItem}>
          DEXTERITY:
          <span className={Styles.specValue}>{attributes.dexterity}</span>
        </div>
      )}
      {attributes?.loft && (
        <div className={Styles.specItem}>
          LOFT:
          <span className={Styles.specValue}>{attributes.loft}</span>
        </div>
      )}
      {attributes?.hosel && (
        <div className={Styles.specItem}>
          HOSEL CODE:
          <span className={Styles.specValue}>{attributes.hosel}</span>
        </div>
      )}
      {attributes?.swingweight && (
        <div className={Styles.specItem}>
          SWING WEIGHT:
          <span className={Styles.specValue}>{attributes.swingweight}</span>
        </div>
      )}
      {attributes?.weightadjust && (
        <div className={Styles.specItem}>
          WEIGHT ADJUST:
          <span className={Styles.specValue}>{attributes.weightadjust}</span>
        </div>
      )}
      {attributes?.shaft && (
        <div className={Styles.specItem}>
          SHAFT:
          <span className={Styles.specValue}>{attributes.shaft}</span>
        </div>
      )}
      {attributes?.length && (
        <div className={Styles.specItem}>
          LENGTH:
          <span className={Styles.specValue}>{attributes.length}</span>
        </div>
      )}
      {attributes?.grip && (
        <div className={Styles.specItem}>
          GRIP:
          <span className={Styles.specValue}>{attributes.grip}</span>
        </div>
      )}
      {attributes?.gripsize && (
        <div className={Styles.specItem}>
          GRIP SIZE:
          <span className={Styles.specValue}>{clubItem.gripsize}</span>
        </div>
      )}
      {attributes?.laseretchfont && (
        <div className={Styles.specItem}>
          LASER ETCH FONT:
          <span className={Styles.specValue}>{attributes.laseretchfont}</span>
        </div>
      )}
      {attributes?.laseretchtype && (
        <div className={Styles.specItem}>
          LASER ETCH TYPE:
          <span className={Styles.specValue}>{attributes.laseretchtype}</span>
        </div>
      )}
    </>
  );
};

export default DriverFairwayHybridSpec;
